























































































import { DialogForm } from '@/components/bwaff';
import {Component, Prop} from 'vue-property-decorator';
import Form, {Send} from '@/components/form-base';
import HeaderButtons from '@/components/ui/ui-modal/modal/header-buttons.vue'
import IntegrationsApi from  '@/services/rest/bemob/integrations';
import ErrorAggregator from '@/components/errors/error-aggregator.vue';
import IntegrationMixin from '@/views/settings/integrations/custom-integrations/mixins/integration-mixin';

import { mixins } from 'vue-class-component';


interface mainForm  {
  name:string,
  accessToken:string,
  type:string,
  id?:string,
  clientId?:string,
  meta?:{
    eventSourceUrl?:string
  }
}

@Component({
  components: {
    DialogForm,
    HeaderButtons,
    ErrorAggregator
  }
})
export default class CreateIntegrationDialog extends mixins<Form,IntegrationMixin>(Form,IntegrationMixin) {
  @Prop({ default: {} })
  data: any;

  show: boolean = false;
  loading: boolean = false;
  isEdit: boolean = false;
  tokenEditMode: boolean = false;
  savedToken: string = '';

  integration: Integration = {
    name: '',
    type: '',
    img: {
      src:''
    },
    guideLink: '',
    help: ''
  };
  integrationsApi: IntegrationsApi = new IntegrationsApi();
  form: mainForm = {
    name:'',
    accessToken:'',
    type:'',
    id:''
  };


  errors: any[] = [];
  errorsControlActive: boolean = false;

  close() {
    this.$emit('close');
  }

  @Send(true)
  save(){
    const method = this.isEdit ? 'put' : 'post'

    this.loading = true;
    return this.integrationsApi[method](this.dataToSend).then(()=>{
      this.close();
      this.bus.emit('toast-success', this.t('Integration has been saved'));
    }).catch((error:any) => {
      return Promise.reject(error);
    }).finally(()=>{
      this.loading = false;
    });
  }

  get dataToSend(){
    const { name, accessToken, id, type, clientId = '',meta } = this.form;
    return {
      ...(this.isEdit && { id }),
      ...(this.integration.clientId && { clientId }),
      ...(this.integration.type==='facebook-conversions' && { meta:{eventSourceUrl:meta.eventSourceUrl} }),
      ...((this.isEdit && this.tokenEditMode || !this.isEdit) && { accessToken }),
      name, 
      type
    }
  }


  mounted() {
    this.$on('error', (e: any, payload: any) => {
      this.$store.commit('loading', false);
      
      // move errors from field 'meta'
      const errorsRaw = {
        ...e.data.errors,
        ...(e.data.errors?.meta || {}),
      }
      
      delete errorsRaw.meta
      
      this.errors = this.translateErrors(this.parseErrors(errorsRaw), e.data.message);
      this.errorsControlActive = true;
    });

    const { type } = this.data;
    this.integration = this.integrationsData[type]

    if(this.integration.type === 'facebook-conversions'){
      this.form.meta = {
        eventSourceUrl:''
      };
    }

    if(this.integration.clientId){
      this.form.clientId = '';
    }
    
    this.form = {
    ...this.form,
    ...this.data
    };


    this.tokenEditMode = false;
    if(this.data.id){
      this.isEdit = true;
      this.savedToken = this.data.accessToken;
    }

    this.show = true;
  }

  handleEditTokenMode() {
    if(this.tokenEditMode){
      this.form.accessToken=this.savedToken
    }else{
      this.form.accessToken=''
    }
    this.tokenEditMode=!this.tokenEditMode
  }
}
